import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
export const Header = styled.header`
  display: flex;
  width: fit-content;
`
export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Title = styled.h1`
  font-size: ${(props) => props.theme.font.textbase};
  font-weight: 400;
`
